import React, { useState } from "react";
import styles from "./orders.module.css";
import { useSelector, useDispatch } from "react-redux";
import { getPortal, getUser, getCurrOrder } from "../../services/selectors";
import { getCookie } from "../../utils/cookie";
import { TypeEditOrder } from "../../utils/constants";
import { checkShipment } from "../../utils/util_functions";
import { patchOrderThunk } from "../../services/actions/orders_actions";
import ChoiceShipping from "../../components/choice_shipping/choice_shipping";
import { getShippings, getMyFirms } from "../../services/selectors";
import ChoiceFirm from "../choice_firm/choice_firm";


const EditOrder = () => {

  const dispatch = useDispatch();

  const { title, typeEditOrder, customer, order } = useSelector(getPortal);
  const user = useSelector(getUser);
  const firms = useSelector(getMyFirms);
  const shippings = useSelector(getShippings);
  const [newComment, setNewComment] = useState(order.comment);
  const [newFirm, setNewFirm] = useState(order.firm);
  const [showFirmsList, setShowFirmsList] = useState(false);
  const [customerFirm, setCustomerFirm] = useState(null);

  const [newOrderShipping, setNewOrderShipping] = useState({
    name: order.order_shipping_name,
    description: order.order_shipping_description,
    type: shippings.find(shipping => shipping.name === order.order_shipping_name).type
  });

  const [showShippingsList, setShowShippingsList] = useState(false);
  const [formValid, setFormValid] = useState(false);

  const accessToken = getCookie('accessToken') || '';
  const refreshToken = getCookie('refreshToken') || '';


  const handleClick = () => {
    let data = null;
    if (typeEditOrder === TypeEditOrder.EditComment) {
      data = { comment: newComment }
    } else if (typeEditOrder === TypeEditOrder.EditFirm) {
      data = { firm: newFirm }
    } else if (typeEditOrder === TypeEditOrder.EditProducts) {
      // data = {products_cast: newProductsCast}
    } else if (typeEditOrder === TypeEditOrder.EditShipping) {
      data = {
        order_shipping_name: newOrderShipping.name,
        order_shipping_description: newOrderShipping.description,
      }
    }
    dispatch(patchOrderThunk(accessToken, refreshToken, order.id, data));
  }

  const changeComment = (e) => {
    if (e.target.value.length > 265) {
      e.target.value = e.target.value.slice(0, 265);
    }
    setNewComment(e.target.value);
  }

  const handleApplyShipping = (name, description, shippings) => {
    const find_shipping = shippings.find(shipping => shipping.name === name);
    setNewOrderShipping({
      ...newOrderShipping,
      id: find_shipping.id,
      active: true,
      type: find_shipping.type,
      name: find_shipping.name,
      description,
    });
  }

  return (
    <div className={styles.edit_container}>
      <h2 className={`title ${styles.edit_title}`}>{title}</h2>

      {typeEditOrder === TypeEditOrder.EditComment &&
        <textarea name="comment" id="comment" className="textarea"
          onChange={changeComment} value={newComment}
          placeholder="Текст до 256 символов"
        />
      }

      {typeEditOrder === TypeEditOrder.EditShipping &&
        <>
          {(customer?.last_ship_name || customer?.pre_last_ship_name) &&
            <>
              <p className="fsm3">Предыдущие способы получения:</p>
              {customer?.pre_last_ship_name && shippings?.length &&
                checkShipment(shippings, customer.pre_last_ship_name) &&
                <div className="lastShipContainer">
                  <div className="lastShipTextContainer">
                    <div className="lastShipName">
                      <p className="fsm3">
                        {customer.pre_last_ship_name}
                      </p>
                    </div>
                    <div className="lastShipDescription">
                      <p className="fsm3">{customer.pre_last_ship_description}</p>
                    </div>
                  </div>
                  <button
                    className="button button__small mla"
                    type="button"
                    onClick={() => handleApplyShipping(
                      customer.pre_last_ship_name, customer.pre_last_ship_description, shippings
                    )}
                  >
                    Повторить
                  </button>
                </div>
              }
              {customer?.last_ship_name && shippings?.length &&
                checkShipment(shippings, customer.last_ship_name) &&
                <div className="lastShipContainer">
                  <div className="lastShipTextContainer">
                    <div className="lastShipName">
                      <p className="fsm3">
                        {customer.last_ship_name}
                      </p>
                    </div>
                    <div className="lastShipDescription">
                      <p className="fsm3">{customer.last_ship_description}</p>
                    </div>
                  </div>
                  <button
                    className="button button__small mla"
                    type="button"
                    onClick={() => handleApplyShipping(
                      customer.last_ship_name, customer.last_ship_description, shippings
                    )}
                  >
                    Повторить
                  </button>
                </div>
              }
            </>
          }
          <p className="fsm3 mt20 fw500">Укажите способ получения этого заказа:</p>
          <div className="shipContainer">
            <ChoiceShipping
              shippings={shippings} orderShipping={newOrderShipping} setOrderShipping={setNewOrderShipping}
              showShippingsList={showShippingsList} setShowShippingsList={setShowShippingsList}
              setFormValid={setFormValid} long={false}
            />
          </div>
        </>
      }

      {(typeEditOrder === TypeEditOrder.EditFirm) &&
        <ChoiceFirm
          firms={firms} currFirm={order.firm} setFirm={setNewFirm}
          showFirmsList={showFirmsList} setShowFirmsList={setShowFirmsList}
          setFormValid={setFormValid}
        />
      }

      {/* тут кнопка сохранения */}
      {(typeEditOrder === TypeEditOrder.EditComment) ?
        <button className={`button mb20`} onClick={handleClick}
        >
          Сохранить
        </button> :
        <button onClick={handleClick}
          className={`button mb20 ${!formValid ? 'button_disabled' : ''}`}
          disabled={!formValid}
        >
          Сохранить
        </button>
      }

    </div>
  )
}

export default EditOrder;
